import { GridGroup } from './grid-group';

export class FrozenGroup extends GridGroup {}
